import {
  MainLayout,
  MainLayoutProps,
} from '../../../components/Layout/MainLayout';
import { Alert } from '@mui/material';
import Loading from '@components/shared/Loading';
import {
  UseCampaignHook,
  useCampaignParameters,
} from '@features/campaigns/subdomains/visitation/hooks/useCampaign';
import { stringify } from 'qs';
import { ReactElement } from 'react';

export type DetailsProps = {
  campaignId: number;
  campaignName: string;
  campaignStartDate: string;
  campaignEndDate: string;
  brand: string | null;
  reportDates: readonly string[];
  channels: readonly string[];
};

export type CampaignLayoutProps = Pick<MainLayoutProps, 'breadcrumbs'> & {
  basePath: string;
  renderDetails: (props: DetailsProps) => ReactElement;
  campaignHook: UseCampaignHook;
};

export const CampaignLayout = (props: CampaignLayoutProps) => {
  const { campaign, isFetching } = props.campaignHook;
  const { id: campaignId, ...queryParams } = useCampaignParameters(
    campaign?.id
  );

  if (isFetching) return <Loading />;

  if (!campaign) return <Alert severity="error">Unable to load campaign</Alert>;

  const campaignPath = [props.basePath, campaignId].join('/');

  const newBreadcrumbs: MainLayoutProps['breadcrumbs'] = [
    ...props.breadcrumbs,
    {
      path: [campaignPath, stringify(queryParams)].join('?'),
      label: campaign.name,
    },
  ];

  return (
    <MainLayout breadcrumbs={newBreadcrumbs}>
      <props.renderDetails
        campaignId={campaign.id}
        campaignName={campaign.name}
        campaignStartDate={campaign.startDate}
        campaignEndDate={campaign.endDate}
        reportDates={campaign.reportDates}
        channels={campaign.channels}
        brand={campaign.brand}
      />
    </MainLayout>
  );
};
